import { BizType } from '@eastcoal/shared/enums/BizType'

// 煤炭专区对应的品种
export const COAL_ZONE_KIND_CODES = [
  // 炼焦煤
  '001',
  // 动力煤
  '002',
  // 无烟煤
  '004'
]

// 化工专区对应的品种
export const CHEMICAL_ZONE_KIND_CODES = [
  // 煤化品
  '007',
  // PVC产品
  '009'
]

// 品种 code 与名称映射
export const KIND_CODE_TEXT_MAP = {
  '001': '炼焦煤',
  '002': '动力煤',
  '004': '无烟煤',
  '007': '煤化品',
  '009': 'PVC产品'
}

// 销售类竞价
export const SALE_TRADE_SESSION_TYPES = [
  BizType.TRADITION_AUCTION,
  BizType.HOUSE_AUCTION,
  BizType.RANKING_AUCTION,
  BizType.SECRET_AUCTION
]

// 采购类竞价
export const PURCHASE_TRADE_SESSION_TYPES = [
  BizType.INQUIRY_AUCTION,
  BizType.TENDER_AUCTION
]
